import React from "react";

const Drag = () => {
    return <div className={"drag"}>||| </div>;
};

export default Drag;
